module.exports = __webpack_public_path__ + "img/black.21a14aab.jpg";